<template>
  <div class="text-center">
    <v-dialog v-model="shower" width="1200" scrollable persistent>
      <!-- {{ _detail }} -->
      <v-card class="rounded-lg">
        <v-card-title>
          {{ $t("petition.text11") }}<v-spacer></v-spacer>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-6">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout row wrap justify-center align-center>
              <v-flex xs11 lg11 ma-2>
                <b>{{ $t("petition.text26") }}</b>
                <v-card
                  outlined
                  color="rgb(228 228 228)"
                  style="text-indent: 1rem"
                >
                  <v-card-text
                    ><b>{{ $t("petition.text25") }}</b></v-card-text
                  >
                </v-card>
              </v-flex>
              <v-flex xs11 lg6 pa-1>
                <b class="red--text mr-1">*</b>
                <b>{{ $t("petition.text27") }}</b> <br />
                <v-select
                  outlined
                  dense
                  color="#077893"
                  return-object
                  clearable
                  :items="GetTypeRequest"
                  :filled="_detail.Pettition === 'pending'"
                  :disabled="_detail.Pettition === 'pending'"
                  item-text="Name"
                  item-value="TypeRequestId"
                  v-model="SelectValueType"
                  :rules="[(v) => !!v || $t('petition.text34')]"
                ></v-select>
              </v-flex>
              <v-flex xs11 lg5 pa-1>
                <b class="red--text mr-1">*</b>
                <b>{{ $t("Profile.fileUpload") }}</b> <br />
                <v-file-input
                  accept=".pdf, image/png, image/jpeg"
                  multiple
                  dense
                  v-model="files"
                  :filled="_detail.Pettition === 'pending'"
                  :disabled="_detail.Pettition === 'pending'"
                  color="#077893"
                  counter
                  prepend-icon=""
                  outlined
                  show-size
                  :rules="rules"
                >
                  <template v-slot:selection="{ index, text }">
                    <v-chip v-if="index < 2" color="#077893" dark label small>
                      {{ text }}
                    </v-chip>

                    <span
                      v-else-if="index === 2"
                      class="text-overline grey--text text--darken-3 mx-2"
                    >
                      +{{ files.length - 2 }} File(s)
                    </span>
                  </template>
                </v-file-input>

                <v-spacer></v-spacer>
              </v-flex>
              <!-- <v-flex xs11 lg6 ma-3 mt-n4>
                <b class="red--text mr-1">*</b>
                <b>{{ $t("petition.text42") }}</b> <br />
                <v-select
                  outlined
                  dense
                  color="#077893"
                  clearable
                  :items="DataDPC"
                  item-value="AccountId"
                  item-text="NameTh"
                  v-model="SelectNameRequest"
                  :rules="[(v) => !!v || $t('petition.text42')]"
                ></v-select>
              </v-flex> -->
              <v-flex xs11 lg11 ma-2 mt-n2>
                <b class="red--text mr-1">*</b>
                <b>{{ $t("petition.text28") }}</b> <br />
                <v-card outlined class="mt-1">
                  <v-card-text>
                    <v-data-table
                      calculate-widths
                      hide-default-footer
                      dense
                      :headers="headers"
                      :items="_Tag"
                      class="elevation-0"
                    >
                      <!-- <template v-slot:body v-if="_load === true">
                      <tr>
                        <td colspan="12">
                          <br />
                          <center>
                            <v-progress-circular
                              :size="30"
                              :width="5"
                              color="#077893"
                              indeterminate
                            >
                            </v-progress-circular>
                          </center>
                        </td>
                      </tr>
                    </template> -->
                      <template v-slot:[`item.checkbox`]="{ item }">
                        <v-checkbox
                          @change="CheckMessage(item)"
                          @click="item.checkbox = !item.checkbox ? true : false"
                          :disabled="
                            item.Status == false ||
                            item.Status == 'pending' ||
                            item.Status == 'wait' ||
                            item.Status == 'approve'
                          "
                          color="#077893"
                          v-model="ItemPetition"
                          :value="item"
                        ></v-checkbox>
                        <!-- {{ item.checkbox }} -->
                        <!-- {{ checkbox }} -->
                      </template>
                      <template v-slot:[`item.action`]="{ item }">
                        <v-text-field
                          @input="CheckMessage(item)"
                          :error-messages="item.messageerror"
                          :disabled="
                            item.Status == false ||
                            item.Status == 'pending' ||
                            item.Status == 'approve' ||
                            item.Status == 'wait' ||
                            item.checkbox == false ||
                            item.checkbox == null
                          "
                          color="#077893"
                          class="my-5"
                          outlined
                          dense
                          hide-details
                          v-model="item.ReqMessage"
                        ></v-text-field>
                        <v-chip
                          label
                          class="mt-n5"
                          v-if="item.Status === 'unapprove'"
                          color="error"
                          small
                          dark
                        >
                          <v-icon small left> mdi-nature </v-icon> เหตุผล :
                          {{ item.CanReasons }}</v-chip
                        >
                      </template>
                      <template v-slot:[`item.note`]="{ item }">
                        <v-chip
                          v-if="item.Status === 'approve'"
                          color="purple"
                          small
                          dark
                        >
                          {{ $t("consentlist.status4") }}
                        </v-chip>
                        <v-chip
                          v-else-if="item.Status === 'unapprove'"
                          color="red"
                          small
                          dark
                        >
                          ปฎิเสธคำร้อง
                        </v-chip>
                        <v-chip
                          v-else-if="item.Status === 'true'"
                          color="teal"
                          small
                          dark
                        >
                          {{ $t("petition.text22v2") }}
                        </v-chip>
                        <v-chip
                          v-else-if="item.Status === 'false'"
                          color="info"
                          small
                          dark
                        >
                          {{ $t("petition.text39") }}</v-chip
                        >
                        <v-chip
                          v-else-if="item.Status === 'wait'"
                          color="info"
                          small
                          dark
                        >
                          {{ $t("consentlist.status3") }}</v-chip
                        >
                        <v-chip
                          v-else-if="item.Status === 'pending'"
                          color="warning"
                          small
                          dark
                        >
                          {{ $t("petition.text38") }}</v-chip
                        >
                        <!-- <v-chip
                          v-if="item.Step === '1'"
                          color="teal"
                          small
                          dark
                        >
                          {{ $t("consentlist.status1") }}
                        </v-chip>
                        <v-chip
                          v-if="item.Step === '2'"
                          color="info"
                          small
                          dark
                        >
                          {{ $t("consentlist.status2") }}
                        </v-chip>
                        <v-chip
                          v-if="item.Step === '3'"
                          color="indigo"
                          small
                          dark
                        >
                          {{ $t("consentlist.status3") }}
                        </v-chip>
                        <v-chip
                          v-if="item.Step === '4'"
                          color="purple"
                          small
                          dark
                        >
                          {{ $t("consentlist.status4") }}
                        </v-chip> -->
                        <!-- <div v-if="item.Status === 'false'">
                          <v-chip color="error" small dark>
                            {{ $t("petition.text39") }}</v-chip
                          >
                        </div>
                        <div v-else-if="item.Status === 'true'">
                          <v-chip color="success" small dark>
                            {{ $t("petition.text22v2") }}</v-chip
                          >
                        </div>
                        <div v-else-if="item.Status === 'approve'">
                          <v-chip color="indigo" small dark> อนุมัติ</v-chip>
                        </div>
                        <div v-else-if="item.Status === 'pending'">
                          <v-chip color="warning" small dark>
                            {{ $t("petition.text38") }}</v-chip
                          >
                        </div>
                        <div v-else-if="item.Status === 'unapprove'">
                          <v-chip color="error" small dark>
                            {{ $t("petition.text16") }}</v-chip
                          >
                        </div>
                        <div v-else-if="item.Status === 'wait'">
                          <v-chip color="indigo" small dark>
                            แจ้งวันที่ดำเนินการ</v-chip
                          >
                        </div> -->
                      </template>
                      <template v-slot:[`item.DueDate`]="{ item }">
                        <div v-if="item.DueDate == ''">-</div>
                        <div v-else>
                          {{ item.DueDate }}
                        </div>
                      </template>
                      <template v-slot:[`item.ReqDtm`]="{ item }">
                        <div v-if="item.ReqDtm == ''">-</div>
                        <div v-else>
                          {{ item.ReqDtm }}
                        </div>
                      </template>
                      <template v-slot:[`item.Step`]="{ item }">
                        <v-tooltip top color="rgb(0 0 0 / 0%)">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              color="#077893"
                              dark
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-tooltip-text
                            </v-icon>
                          </template>
                          <v-stepper
                            :value="item.Step"
                            class="mt-12"
                            alt-labels
                            width="80vh"
                          >
                            <v-stepper-header>
                              <v-stepper-step step="1" color="teal">
                                <div
                                  class="text-center"
                                  style="font-size: 12px"
                                >
                                  {{ $t("consentlist.status1") }}
                                </div>
                              </v-stepper-step>
                              <v-divider></v-divider>
                              <v-stepper-step step="2" color="info">
                                <div
                                  class="text-center"
                                  style="font-size: 12px"
                                >
                                  {{ $t("consentlist.status2") }}
                                </div>
                              </v-stepper-step>
                              <v-divider></v-divider>
                              <v-stepper-step step="3" color="indigo">
                                <div
                                  class="text-center"
                                  style="font-size: 12px"
                                >
                                  {{ $t("consentlist.status3") }}
                                </div>
                              </v-stepper-step>
                              <v-divider></v-divider>
                              <v-stepper-step step="4" color="purple">
                                <div
                                  class="text-center"
                                  style="font-size: 12px"
                                >
                                  {{ $t("consentlist.status4") }}
                                </div>
                              </v-stepper-step>
                            </v-stepper-header>
                          </v-stepper>
                        </v-tooltip>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-flex>
              <!-- <v-flex xs11 lg11 ma-2>
                <b class="red--text mr-1">*</b>
                <b>
                  {{ SelectValueType.Details }} {{ $t("petition.text33") }}</b
                >
                <br />
                <v-textarea
                  filled
                  outlined
                  dense
                  hide-details
                  color="#077893"
                  v-model="SubjectRequest"
                  :label="$t('petition.text11')"
                ></v-textarea>
              </v-flex> -->
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions class="pb-5 pa-3">
          <v-spacer></v-spacer>
          <v-btn color="error" outlined @click="Fn_Close()" dark>
            {{ $t("consentform.close") }}
          </v-btn>
          <v-btn
            :dark="_detail.Pettition != 'pending'"
            color="#077893"
            @click="Request_Cancel"
            :loading="loading"
            :disabled="_detail.Pettition === 'pending'"
          >
            {{ $t("consentlist.petitionBtn") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";
// import { mapGetters } from 'vuex'
const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

export default {
  props: ["show", "_detail", "GetTypeRequest", "_Tag"],
  data: function () {
    return {
      valid: true,
      SubjectRequest: "",
      loading: false,
      dis: false,
      name: "",
      surname: "",
      phone: "",
      email: "",
      SelectValueType: "",
      TypeRequest: "",
      // DataDPC: [],
      rules: [
        (v) => !!v || "กรุณาแนบไฟล์เพื่อยืนยันข้อมูล",
        (v) => (v && v.length > 0) || "กรุณาแนบไฟล์เพื่อยืนยันข้อมูล",
      ],
      // rules: {
      //   required: (value) => !!value || 'Required.'
      // },
      // rules: {
      //   email: value => {
      //     const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      //     return pattern.test(value) || 'Invalid e-mail.'
      //   },
      // },
      singleSelect: false,
      selected: [],
      SelectNameRequest: "",
      ItemPetition: [],
      checkbox: false,
      btnLoad: false,
      messageerror: "กรุณากรอกชื่อ",
      files: [],
      previousFiles: [],
      // _Tag: [],
      myStr: [],
    };
  },
  computed: {
    shower: {
      ...mapGetters(["DataPetition"]),
      _SendId: {
        get() {
          return this.DataPetition.SendId || "-";
        },
      },
      _SubjectRequest: {
        get() {
          return this.DataPetition.SubjectRequest || "-";
        },
      },
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.$emit("closeDialog");
          this.checkbox = false;
        }
      },
    },
    headers() {
      return [
        {
          text: this.$i18n.t("NewUpdate.use"),
          value: "checkbox",
          sortable: false,
          align: "center",
        },
        {
          text: this.$i18n.t("NewUpdate.dataRequest"),
          value: "Key",
          sortable: false,
          align: "left",
        },
        {
          text: this.$i18n.t("NewUpdate.reason"),
          align: "center",
          value: "action",
          sortable: false,
        },
        {
          text: this.$i18n.t("NewUpdate.status"),
          align: "left",
          value: "note",
          sortable: false,
        },
        {
          text: this.$i18n.t("NewUpdate.ReqDtm"),
          align: "center",
          value: "ReqDtm",
          sortable: false,
        },
        {
          text: this.$i18n.t("NewUpdate.text1"),
          align: "center",
          value: "DueDate",
          sortable: false,
        },
        {
          text: "ขั้นตอนการยื่นคำร้อง",
          align: "center",
          value: "Step",
          sortable: false,
        },
      ];
    },
  },
  methods: {
    async CheckMessage(val) {
      if (val.ReqMessage === "") {
        val.messageerror = "กรุณากรอกชื่อ";
      } else {
        val.messageerror = "";
      }
    },
    handleFileUpload(event) {
      const files = event.target.files;
      const fileData = [];

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const reader = new FileReader();

        reader.onload = (e) => {
          fileData.push({
            name: file.name,
            data: e.target.result,
          });

          if (fileData.length === files.length) {
            // ทำสิ่งที่ต้องการกับข้อมูลไฟล์ที่ถูกอัพโหลดทั้งหมด
          }
        };

        reader.readAsDataURL(file);
      }
    },
    Fn_Close() {
      this.$emit("closeDialog");
      this.SelectValueType = "";
      this.SubjectRequest = "";
      this.ItemPetition = [];
      this.checkbox = false;

      this.$refs.form.resetValidation();
      // window.location.reload();formTag
    },
    // async Fn_GetDPC () {
    //   this.loadingDownloadData = true
    //   var payload = {
    //     AccountId: this.$cookies.get('OneAccountId'),
    //     BusinessId: this.$cookies.get('BusinessId'),
    //     AccessToken: this.$cookies.get('OneAccessToken')
    //   }
    //   var Headers = {
    //     AccountId: this.$cookies.get('OneAccountId')
    //   }
    //   var dataEncode = await authorization.encodeDataNew(payload)
    //   var auth = await authorization.encodeDataNew(Headers)
    //   var headers = { Authorization: 'Bearer ' + auth }
    //   this.axios
    //     .post(
    //       process.env.VUE_APP_API_FACTORING_SERVICE +
    //         'business/Pettition/GetDPC',
    //       { Data: dataEncode },
    //       { headers }
    //     )
    //     .then((response) => {
    //       this.loadingDownloadData = false
    //       if (response.data.Status === 'OK') {
    //         this.DataDPC = response.data.Message
    //       } else {
    //         Toast.fire({
    //           icon: 'error',
    //           title: response.data.Message.Status
    //         })
    //       }
    //     })
    //     .catch((error) => {
    //       this.loading = false
    //       if (error.response) {
    //         Toast.fire({
    //           icon: 'error',
    //           title: error.response.data.ErrorMessage
    //         })
    //       } else if (error.request) {
    //         Toast.fire({
    //           icon: 'error',
    //           title: error.request
    //         })
    //       } else {
    //         Toast.fire({
    //           icon: 'error',
    //           title: error.message || error
    //         })
    //       }
    //     })
    // },
    async Request_Cancel() {
      const newData = this.ItemPetition.map((item) => {
        const { DueDate, checkbox, ...newItem } = item;
        return newItem;
      });
      this.myStr = JSON.stringify(newData);
      var checkText = newData.every((newData) => newData.messageerror === "");

      if (this.$refs.form.validate() && checkText === true) {
        this.loading = true;
        var formData = new FormData();
        for (const i of this.files) {
          formData.append("File", i);
        }
        formData.append("Email", this.$cookies.get("EmailCMP"));
        formData.append("SendId", this._detail.SendId);
        formData.append("TypeRequstId", this.SelectValueType.TypeRequestId);
        formData.append("BusinessId", this._detail.BusinessId);
        formData.append("AccessToken", this.$cookies.get("EmailAccessToken"));
        formData.append("Tag", this.myStr);
        this.axios
          .post(
            process.env.VUE_APP_API_FACTORING_SERVICE +
              "email/Pettition/Request",
            formData
            // { Data: dataEncode },
            // { headers }
          )
          .then((response) => {
            // this.loading = false;
            if (response.data.Status === "OK") {
              this.loading = false;
              Toast.fire({
                icon: "success",
                title: response.data.Message,
              });
              this.$emit("closeDialog");
            } else {
              Toast.fire({
                icon: "error",
                title: response.data.Message.Status,
              });
              this.loading = false;
            }
          })
          .catch((error) => {
            this.loading = false;
            this.messageerror = "กรุณากรอกชื่อ";
            if (error.response) {
              Toast.fire({
                icon: "error",
                title: error.response.data.ErrorMessage,
              });
            } else if (error.request) {
              Toast.fire({
                icon: "error",
                title: error.request,
              });
            } else {
              Toast.fire({
                icon: "error",
                title: error.message || error,
              });
            }
          });
      } else {
        this.messageerror = "กรุณากรอกชื่อ";
        Toast.fire({
          icon: "error",
          title: this.$i18n.t("NewUpdate.text5"),
        });
      }
    },
  },
  watch: {
    show(val) {
      if (val == true) {
        if (this.ItemPetition == "") {
          this.ItemPetition = [];
          this.checkbox = false;
          this.files = [];
          // this.SelectNameRequest = ''
          this.SelectValueType = "";
          this.$refs.form.reset();
        }
      } else if (val == false) {
        val = false;
      }
    },
  },
};
</script>
